// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C9vO1","content":"styles_content__22bmA"};